var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarDay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.121,
    height: 15.225,
    viewBox: "0 0 14.121 15.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-546.735 -534.112)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(546.985 535.728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.139,561.188a1.457,1.457,0,0,0,1.466-1.445V549.274a1.457,1.457,0,0,0-1.466-1.445H548.451a1.457,1.457,0,0,0-1.466,1.445v10.469a1.457,1.457,0,0,0,1.466,1.445Zm-11.546-1.445V549.274a.852.852,0,0,1,.858-.845h10.688a.852.852,0,0,1,.858.845v10.469a.852.852,0,0,1-.858.845H548.451A.852.852,0,0,1,547.593,559.743Z",
    transform: "translate(-546.985 -547.829)",
    fill: "#e8716d",
    stroke: "#e8716d",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(550.608 534.362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.7,537.526v-2.809a.355.355,0,0,0-.71,0v2.809a.355.355,0,0,0,.71,0Z",
    transform: "translate(-588.991 -534.362)",
    fill: "#e8716d",
    stroke: "#e8716d",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(556.339 534.362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M656.145,537.526v-2.809a.355.355,0,0,0-.71,0v2.809a.355.355,0,0,0,.71,0Z",
    transform: "translate(-655.435 -534.362)",
    fill: "#e8716d",
    stroke: "#e8716d",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(547.34 538.457)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.833,
    height: 0.71,
    transform: "translate(0 0)",
    fill: "#e8716d",
    stroke: "#e8716d",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(551.908 540.793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608.613,620.35a.354.354,0,0,0,.468-.18l2.168-4.872a.355.355,0,0,0-.324-.5H607.5a.355.355,0,0,0,0,.71h2.88l-1.946,4.372A.355.355,0,0,0,608.613,620.35Z",
    transform: "translate(-607.144 -614.799)",
    fill: "#e8716d",
    stroke: "#e8716d",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDay);
export default __webpack_public_path__ + "static/media/calendar-day.02a362e4.svg";
export { ForwardRef as ReactComponent };